// extracted by mini-css-extract-plugin
export default {"container":"logo_container__CeIZc","img":"logo_img__6ySCU"};